<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 10:25:39
 * @LastEditors: mdb
-->
<template>
  <ActivityCode :permission="permission" subdomain="fbu" paramCode="zbu_source_channel_fbu" />
</template>

<script setup lang="ts">
import ActivityCode from '@/views/marketing/marketingManage/activityCode/index.vue'

const permission = {
  add: 'fbu_activity_add_btn',
  edit: 'fbu_activity_edit_btn',
  delete: 'fbu_activity_del_btn',
  enable: 'fbu_activity_enable_btn',
  disable: 'fbu_activity_disable_btn',
  qrcode: 'fbu_activity_qrcode_btn',
  card: 'fbu_activity_card_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuActivityCode' }
</script>

<style scoped></style>
